import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ErrorDisplayComponent } from './error-display.component';

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [
    ErrorDisplayComponent
  ],
  exports: [
    ErrorDisplayComponent
  ]
})
export class ErrorDisplayModule { }



// WEBPACK FOOTER //
// /dist/src/app/shared/error-display/error-display.module.ts